var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "directory-actions" },
    [
      _c("DottedDropdown", { attrs: { id: "dir-action-" + _vm.id } }, [
        _vm.canEdit
          ? _c("li", [
              _c(
                "button",
                {
                  staticClass: "btn btn--transparent",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.edit()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("action.edit")))]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.canEditPublished
          ? _c("li", [
              _c(
                "button",
                {
                  staticClass: "btn btn--transparent",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.action(_vm.ACTION.editPublished)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("action.edit")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn--transparent",
                  attrs: { type: "button" },
                  on: { click: _vm.remove },
                },
                [_vm._v(_vm._s(_vm.$t("action.remove")))]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.showUndo
          ? _c("li", [
              _c(
                "button",
                {
                  staticClass: "btn btn--transparent",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.action(_vm.ACTION.undoRemove)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("action.undo")))]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.canCancel
          ? _c("li", [
              _c(
                "button",
                {
                  staticClass: "btn btn--transparent",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.action(_vm.ACTION.cancelRequest)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("directory.action.cancelRequest")))]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("li", [
          _c(
            "button",
            {
              staticClass: "btn btn--transparent",
              attrs: { type: "button" },
              on: { click: _vm.openCommentsHistory },
            },
            [_vm._v(_vm._s(_vm.$t("directory.action.commentsHistory")))]
          ),
        ]),
        _vm._v(" "),
        _c("li", [
          _c(
            "button",
            {
              staticClass: "btn btn--transparent",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.showAttachments()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("attachments")))]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "Modal",
        { ref: "alertActionMsg", attrs: { modalId: _vm.id + "-dir-action" } },
        [
          _c(
            "div",
            {
              staticClass: "font-bold",
              attrs: { slot: "content" },
              slot: "content",
            },
            [_c("div", { domProps: { innerHTML: _vm._s(_vm.alertMsg) } })]
          ),
          _vm._v(" "),
          _c("div", { attrs: { slot: "btns" }, slot: "btns" }, [
            _c(
              "button",
              {
                staticClass: "btn btn--orange close-reveal-modal",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.doIt()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("action.yesContinue")))]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "attachmentsDetail",
          attrs: {
            modalId: _vm.id + "-dir-attachments",
            modalType: "medium-modal",
            showCloseBtn: false,
          },
        },
        [
          _c("p", { staticClass: "font-bold" }, [
            _vm._v(_vm._s(_vm.$t("directory.label.documents"))),
          ]),
          _vm._v(" "),
          _c("EditAttachments", {
            ref: "editAttachments",
            staticClass: "directory-actions__edit-attachments",
            attrs: {
              canDelete: false,
              canEdit: false,
              sourceId: _vm.attachmentId,
              showEmptyMsg: true,
              emptyMsg: _vm.$t("directory.msg.emptyDocHint"),
            },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "row align-center nav_btn",
              attrs: { slot: "btns" },
              slot: "btns",
            },
            [
              _c(
                "button",
                {
                  staticClass: "btn btn--orange",
                  attrs: {
                    type: "button",
                    "data-close": "",
                    "aria-label": "Close reveal",
                  },
                },
                [_vm._v(_vm._s(_vm.$t("action.ok")))]
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }